import React, { useEffect, useState, useRef } from "react";
import { Link } from "react-router-dom";
import Collapse from "react-bootstrap/Collapse";
import Select from "react-select";
import AccessoriesServices from "../../../services/AccessoriesService";
import AssetViewModal from "./AssetViewModal";

const AccessoriesList = () => {
    const user = JSON.parse(localStorage.getItem("userDetails"));
  const storeList = user?.data?.user?.store || [];
  const defaultStore = storeList[0]?._id || '';

  const [open, setOpen] = useState(true);
  const [open2, setOpen2] = useState(true);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [data, setData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [sort, setSort] = useState(50);
  const activePag = useRef(0);
  const [test, setTest] = useState(0);
  const [selectedStore, setSelectedStore] = useState(defaultStore);
  const [selectedItem, setSelectedItem] = useState({})
  const [isModelOpen, setIsModelOpen] = useState()
  const [run, setRun] = useState(0)

  

  const options = [
    { value: 10, label: "10" },
    { value: 20, label: "20" },
    { value: 50, label: "50" },
    { value: 100, label: "100" },
  ];

  useEffect(() => {
    setLoading(true);
    AccessoriesServices.getAllAssets()
      .then((response) => {
        const accessories = response?.data?.accessories || [];
        setData(accessories);
        setLoading(false);
      })
      .catch(() => {
        setError("There is some problem in fetching data!");
        setLoading(false);
      });
  }, [test]);

  useEffect(() => {
    const filtered = data.filter((item) => {
      const name = String(item?.name || "").toLowerCase();
      const serialNumber = String(item?.serialNumber || "").toLowerCase();
      const description = String(item?.description || "").toLowerCase();
      const storeId = item?.store?._id;

      const search = searchTerm.toLowerCase();

      const matchesSearch =
        name.includes(search) ||
        serialNumber.includes(search) ||
        description.includes(search);

      const matchesStore =
        !selectedStore || storeId === selectedStore;

      return matchesSearch && matchesStore;
    });

    setFilteredData(filtered);
    activePag.current = 0; // reset to first page on filter
  }, [searchTerm, data, selectedStore]);

  const pagination = Math.ceil(filteredData.length / sort);

  const onClick = (i) => {
    activePag.current = i;
    setTest(i);
  };

  const handleSelectChange = (selectedOption) => {
    setSort(selectedOption.value);
    activePag.current = 0;
  };

  const handleStoreChange = (e) => {
    setSelectedStore(e.target.value);
  };

  const formatDate = (dateString) => {
    if (!dateString) return "-";
    const options = { year: "numeric", month: "short", day: "numeric" };
    return new Date(dateString).toLocaleDateString(undefined, options);
  };

  const paginatedData = filteredData.slice(
    activePag.current * sort,
    (activePag.current + 1) * sort
  );

  const handleViewDeatils = (item) => {
    setSelectedItem(item)
    setIsModelOpen(true)
  }

  return (
    <>
      <AssetViewModal
        item={selectedItem}
        show={isModelOpen}
        handleClose={() => setIsModelOpen(false)}
        onSuccess={() => setRun(prev => prev + 1)}
      />
    <div className="row">
      {loading ? (
        <div className="loader-container">
          <div className="loader"></div>
          <p className="loading-text">Assets Loading...</p>
        </div>
      ) : (
        <div className="col-xl-12">
          <div className="filter cm-content-box box-primary">
            <div className={`content-title`}>
              <div className="cpa">
                <i className="fas fa-filter me-2"></i>Filter
              </div>
              <div className="tools">
                <Link
                  to={"#"}
                  className={`SlideToolHeader ${open ? "collapse" : "expand"}`}
                  onClick={() => setOpen(!open)}
                >
                  <i className="fas fa-angle-up"></i>
                </Link>
              </div>
            </div>
            <Collapse in={open}>
              <div className="cm-content-body form excerpt">
                <div className="card-body">
                  <div className="row">
                    <div className="col-xl-3 col-xxl-4">
                      <input
                        type="text"
                        className="form-control mb-xl-0 mb-3"
                        placeholder="Search by Name, Serial Number, Master Part No, or Description"
                        value={searchTerm}
                        onChange={(e) => setSearchTerm(e.target.value)}
                      />
                    </div>
                    <div className="col-xl-3 col-xxl-4">
                      <select
                        className="form-select mb-xl-0 mb-3 pt-3 pb-3"
                        name="store"
                        value={selectedStore}
                        onChange={handleStoreChange}
                      >
                        {storeList.map((s, index) => (
                          <option key={index} value={s._id}>
                            {`${s.name}, ${s.location}`}
                          </option>
                        ))}
                      </select>
                    </div>
                    <div className="col-xl-3 col-xxl-4">
                      <Select
                        placeholder="Select rows to display"
                        value={options.find((option) => option.value === sort)}
                        onChange={handleSelectChange}
                        isSearchable={false}
                        options={options}
                        className="custom-react-select mb-3 mb-xxl-0"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </Collapse>
          </div>

          <div className="filter cm-content-box box-primary">
            <div className={`content-title`}>
              <div className="cpa">
                <i className="fa fa-list me-2"></i>Accessories List
                <span className="badge bg-orange ms-2">{filteredData.length}</span>
              </div>
              <div className="tools">
                <Link
                  to={"#"}
                  className={`SlideToolHeader ${open2 ? "collapse" : "expand"}`}
                  onClick={() => setOpen2(!open2)}
                >
                  <i className="fas fa-angle-up"></i>
                </Link>
              </div>
            </div>

            <Collapse in={open2}>
              <div className="cm-content-body form excerpt">
                <div className="card-body">
                  <div className="table-responsive">
                    <table className="table table-bordered table-striped" id="transactions-data">
                      <thead>
                        <tr>
                          <th>#</th>
                          <th>Part No</th>
                          <th>Name</th>
                          <th>Asset Serial No.</th>
                          <th>Description</th>
                          <th>Quantity</th>
                          <th>Purchase Date</th>
                          <th>Status</th>
                          <th>Store</th>
                          <th>User</th>
                          <th className="text-center">Asset Deatils</th>
                          
                        </tr>
                      </thead>
                      <tbody>
                        {paginatedData.length > 0 ? (
                          paginatedData.map((item, index) => (
                            <tr key={item._id}>
                              <td>{activePag.current * sort + index + 1}</td>
                              <td>{item?.asset?.masterPart?.partNo || "-"}</td>
                              <td>{item.name || "-"}</td>
                              <td>{item.serialNumber || "-"}</td>
                              <td>{item.description || "-"}</td>
                              <td>{item.quantity || 0}</td>
                              <td>{formatDate(item.purchaseDate)}</td>
                              <td>{item.status || "-"}</td>
                              <td>{item.store?.name || "-"}</td>
                              <td>{item.user?.name || "-"}</td>
                              <td className="text-center">
                              <button
                                        className="btn btn-primary btn-xs sharp"
                                        onClick={() => handleViewDeatils(item)} // Open modal on edit click
                                      >
                                        <i className="fa fa-eye" aria-hidden="true" color="black"></i>
                                      </button>
                              </td>
                              
                            </tr>
                          ))
                        ) : (
                          <tr>
                            <td colSpan="11" className="text-center">
                              No records found.
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </table>

                    <div className="d-flex justify-content-between align-items-center mt-3">
                      <div>
                        Showing {filteredData.length === 0 ? 0 : activePag.current * sort + 1} to{" "}
                        {Math.min(filteredData.length, (activePag.current + 1) * sort)} of{" "}
                        {filteredData.length} entries
                      </div>
                      <div>
                        <button
                          className="btn btn-sm btn-outline-secondary me-2"
                          onClick={() => activePag.current > 0 && onClick(activePag.current - 1)}
                        >
                          &lt; Prev
                        </button>
                        {Array.from({ length: pagination }, (_, i) => (
                          <button
                            key={i}
                            className={`btn btn-sm ${
                              activePag.current === i ? "btn-primary" : "btn-outline-primary"
                            } me-1`}
                            onClick={() => onClick(i)}
                          >
                            {i + 1}
                          </button>
                        ))}
                        <button
                          className="btn btn-sm btn-outline-secondary ms-2"
                          onClick={() =>
                            activePag.current + 1 < pagination && onClick(activePag.current + 1)
                          }
                        >
                          Next &gt;
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </Collapse>
          </div>
        </div>
      )}
    </div>
    </>
  );
};

export default AccessoriesList;
